import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ConnexionService {

  private authenticated = false;

  private codeApporteurAuth: string = null;

  private login: string;

  constructor(private http: HttpClient) {}

  setLogin(login: string) {
    this.login = login;
    this.authenticated = true;
  }

  doAuthentication(data: any): Observable<any> {
    this.authenticated = false;
    return this.http.post(
      environment.apiBaseUrl + 'connexion',
      JSON.stringify(data)
    ).map(
      response => {
        this.codeApporteurAuth = response['codeApporteurNovelia'];
        this.authenticated = true;
      }
    );
  }

  public isAuthenticated(): boolean {
    return this.authenticated;
  }

  public getCodeApporteurAuth() {
    return this.codeApporteurAuth;
  }

  public getLogin() {
    return this.login;
  }

}



// WEBPACK FOOTER //
// ./src/app/connexion.service.ts